import Link from 'next/link';
import { withTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { NS } from '@/constants';
import { BREAKPOINTS_LABELS } from '@/constants/gui';
import LazyVideoPlayer from './LazyVideoPlayer';

export const VideoPresentation = ({ t, data, breakpoint }) => {
	const { text, link, htmlContent, img, video, isNofollow } = data;
	const relAttr = isNofollow ? { rel: 'nofollow' } : {};

	return (
		<div className="video-presentation-container">
			<div className={`video-presentation video-presentation-${breakpoint}`} data-test-id="video-presentation">
				<div className="video-presentation-text" data-test-id="video-presentation-text">
					<div
						className="video-presentation-text-title"
						data-test-id="video-presentation-text-title"
						dangerouslySetInnerHTML={{ __html: text.title || t('home.title') }}
					/>
					<div
						className="video-presentation-text-description"
						data-test-id="video-presentation-text-description"
						dangerouslySetInnerHTML={{ __html: text.desc || t('home.description') }}
					/>
					{htmlContent && (
						<div
							className="video-presentation-text-html-content"
							data-test-id="video-presentation-text-html-content"
							dangerouslySetInnerHTML={{ __html: htmlContent }}
						/>
					)}
					<Link
						href={link.url || '/about-us.html'}
						aria-label={link.label || t('btn.knowMore')}
						data-test-id="link-anchor"
						{...relAttr}
					>
						{link.label || t('btn.knowMore')}
					</Link>
				</div>
				<div className="video-presentation-player">
					<LazyVideoPlayer img={img} video={video} />
				</div>
			</div>
		</div>
	);
};

VideoPresentation.propTypes = {
	data: PropTypes.shape({
		htmlContent: PropTypes.string,
		text: PropTypes.shape({
			title: PropTypes.string,
			desc: PropTypes.string,
		}),
		link: PropTypes.shape({
			label: PropTypes.string,
			url: PropTypes.string,
		}),
		img: PropTypes.string.isRequired,
		video: PropTypes.shape({
			idYoutube: PropTypes.string.isRequired,
		}).isRequired,
		isNofollow: PropTypes.bool,
	}).isRequired,
	breakpoint: PropTypes.oneOf(BREAKPOINTS_LABELS),
};

export default withTranslation(NS.COMMON)(VideoPresentation);
